import log from 'loglevel';
import { caseDetails } from '../../App/App.config';
import { router } from '../../services'
import pushGTMEvent from './../../util/helper/pushGTMEvent'

const createCase = async (
  userSession,
  caseDescription,
  currentCMDetails,
  newCmDetails,
  error,
  credentials,
) => {
  let errorDesc
  let errorMessage
  if (error) {
    errorDesc = error.errorDesc
    errorMessage = error.errorMessage
  }
  let payload = {
    fName: userSession.first,
    lName: userSession.last,
    Email: userSession.email,
    RequestorEmail: userSession.email,
    subscriptionNumber: currentCMDetails.contractNumber || '',
    Description: `Contract Number: ${currentCMDetails.contractNumber}\n
                  Current contract manager's email: ${currentCMDetails.authEmail}\n
                  New contract manager's name: ${newCmDetails.firstName} ${newCmDetails.lastName}\n
                  New contract manager's email: ${newCmDetails.email}\n
                  Error: ${errorDesc}\n
                  Customer comments: ${caseDescription}`,
    newName: `${newCmDetails.firstName} ${newCmDetails.lastName}`,
    ErrorMessage: `${errorMessage}`,
  }

  payload = { ...payload, ...caseDetails }
  try {
    const caseResponse = await router('CASE', payload, credentials)
    return caseResponse
  } catch (err) {
    log.error(err)
  }
}

const asyncCaseCall = async (
  dispatch,
  userSession,
  caseDescription,
  currentCMDetails,
  newCmDetails,
  error,
  credentials,
) => {
  dispatch({ type: 'GO_TO_SPIN_PAGE' })
  try {
    const { data, status } = await createCase(
      userSession,
      caseDescription,
      currentCMDetails,
      newCmDetails,
      error,
      credentials,
    )
    if (data && data.caseNumber && status === 200) {
      pushGTMEvent('CreateCase/Success')
      dispatch({
        type: 'GO_TO_CREAT_CASE_SUCCESS_PAGE',
        payload: { caseNumber: data.caseNumber },
      })
    } else {
      pushGTMEvent('CreateCase/Error')
      dispatch({
        type: 'GO_TO_ERROR_PAGE',
        payload: 'apigeeError',
      })
    }
  } catch (e) {
    pushGTMEvent('CreateCase/Error')
    dispatch({
      type: 'GO_TO_ERROR_PAGE',
      payload: 'apigeeError',
    })
  }
}

export {
  asyncCaseCall as default,
  createCase,
};
